import { Box, Flex } from '@chakra-ui/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

export const RentalSectionHeaderWrapper = styled(Flex)`
  flex-direction: column-reverse;

  > * {
    margin: 0 0 20px;
  }

  @media (min-width: 600px) {
    flex-direction: row;
    align-items: flex-start;
    margin-left: -10px;
    margin-right: -10px;

    > * {
      margin-left: 10px;
      margin-right: 10px;
      flex: 1;
    }
  }
`

export const RentalSectionHeaderSummary = styled(Box)`
  padding: 20px 20px 16px;
  border: 2px solid ${theme.token.var('colors.green.a50')};
  border-radius: ${theme.token.var('borderRadius.small')};
`

export const RentalSectionHeaderSpan = styled('span')`
  color: ${theme.token.var('colors.green.a200')};
`

export const RentalSectionHeaderIconWrapper = styled(Box)`
  width: 20px;
  height: 20px;
  margin-right: 8px;

  position: relative;
  background-color: ${theme.token.var('colors.green.a25')};
  border-radius: 50%;
  color: ${theme.token.var('colors.green.a200')};

  > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export const RentalSectionBigHeaderIconWrapper = styled(Box)`
  width: 36px;
  height: 36px;
  margin-right: 8px;

  position: relative;
  background-color: ${theme.token.var('colors.green.a200')};
  border-radius: 50%;
  color: ${theme.token.var('colors.white')};

  > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`
